// import React,{useState} from "react";


import '../assets/Panshet.css';

import heroimg from '../assets/Panshet/Panshet-hero.png'

import herovideo from '../assets/Panshet/Panshet-hero.mp4';

import expwaterscape from '../assets/Panshet/experience-watercape.mp4'

import family from '../assets/Panshet/family.mp4';


import panshet_map from '../assets/Panshet/panshet-map.png';

import pool from '../assets/Panshet/swimming-pool.png';
import gated from '../assets/Panshet/gated-community.png';
import gate from '../assets/Panshet/gate.png';
import street from '../assets/Panshet/street-light.png';
import well from '../assets/Panshet/well.png';
import watertank from '../assets/Panshet/watertank.png';
import plantation from '../assets/Panshet/plantation.png';

import outdoor from '../assets/Panshet/outdoor.png';

import mountain from '../assets/Panshet/lush-mountain.png';
import waterfall from '../assets/Panshet/waterfall-.png';
import farmhouse from '../assets/Panshet/waterscape-farm.png';

import deer from '../assets/Panshet/deer.png';
import React, { useEffect, useRef, useState } from "react";

import { map } from 'leaflet';

const Panshet = () => {

    const amenities = [
        {
            number: "01",
            name: "Gated Community",
            image: gated,
        },
        {
            number: "02",
            name: "Main Entrance Gate",
            image: gate,
        },
        {
            number: "03",
            name: "Solar street light on MSEB Pol",
            image: street,
        },
        {
            number: "04",
            name: "Well",
            image: well,
        },
        {
            number: "05",
            name: "Water Tank",
            image: watertank,
        },
        {
            number: "06",
            name: "Roadside Plantation",
            image: plantation,
        },
        {
            number: "07",
            name: "Boating ,Kayaking, Fishing ,Jungle Safari,Wildlife",
            image: outdoor,
        },
    ];

    const [activeAmenity, setActiveAmenity] = useState(amenities[0]);


    // ------------------------------------


    const [activeCustomer, setActiveCustomer] = useState(0);


    const customerTestimonials = [
        {
            image: "/images/customers/customer-01.jpg",
            quote: "A beautiful place to step away from the everyday and spend meaningful time with family.",
            name: "Mr.Anand Chandole ",
            role: "Waterscape Homeowner"
        },
        {
            image: "/images/customers/customer-02.jpg",
            quote: "Waterscape gives us the perfect balance of nature, peace and a place we can truly call our own.",
            name: "Mr.Ankit Patel ",
            role: "Waterscape Homeowner"
        },
        {
            image: "/images/customers/customer-03.jpg",
            quote: "What attracted us most was the surroundings. It feels completely different from city living.",
            name: "Mr.Sagar Patel ",
            role: "Waterscape Homeowner"
        },
        {
            image: "/images/customers/customer-04.jpg",
            quote: "A place where we can slow down, spend time together and create memories.",
            name: "Mr.Kewal Chaotaliya ",
            role: "Waterscape Homeowner"
        },
        {
            image: "/images/customers/customer-05.jpg",
            quote: "The location, the landscape and the overall experience made Waterscape an easy choice for us.",
            name: "Mr.Sanket Bhosale ",
            role: "Waterscape Homeowner"
        }
    ];

    const nextCustomer = () => {

        setActiveCustomer((current) =>
            current === customerTestimonials.length - 1
                ? 0
                : current + 1
        );

    };


    const previousCustomer = () => {

        setActiveCustomer((current) =>
            current === 0
                ? customerTestimonials.length - 1
                : current - 1
        );

    };


    // -----------------------------------------------------------------------------


    const naturalUspRef = useRef(null);

    const [naturalUspProgress, setNaturalUspProgress] = useState(0);

    useEffect(() => {

        const handleNaturalUspScroll = () => {

            if (!naturalUspRef.current) return;

            const section = naturalUspRef.current;

            const rect = section.getBoundingClientRect();

            const sectionHeight = section.offsetHeight;

            const viewportHeight = window.innerHeight;

            /*
             * How far the user has travelled
             * through the sticky section.
             */

            const scrollDistance =
                sectionHeight - viewportHeight;

            const currentScroll =
                -rect.top;

            let progress =
                currentScroll / scrollDistance;

            progress = Math.max(
                0,
                Math.min(progress, 1)
            );

            setNaturalUspProgress(progress);

        };


        window.addEventListener(
            "scroll",
            handleNaturalUspScroll,
            { passive: true }
        );

        handleNaturalUspScroll();


        return () => {

            window.removeEventListener(
                "scroll",
                handleNaturalUspScroll
            );

        };

    }, []);

    return (
        <main className="panshet-container">

            {/* =====================================================
          HEADER
      ===================================================== */}
            {/* <header className="panshet-header">

                <div className="panshet-header-logo">
                    <a href="/" aria-label="Samriddhi Home">
                        <span className="panshet-logo-mark">◈</span>

                        <span className="panshet-logo-text">
                            SAMRIDDHI
                            <small>BUILT ON TRUST</small>
                        </span>
                    </a>
                </div>

                <nav className="panshet-navigation">
                    <a href="#projects">Projects</a>
                    <a href="#about">About Us</a>
                    <a href="#lifestyle">Lifestyle</a>
                    <a href="#legacy">Our Legacy</a>
                    <a href="#contact">Contact</a>
                </nav>

                <div className="panshet-header-actions">

                    <button className="panshet-enquire-button">
                        Enquire Now
                    </button>

                    <button
                        className="panshet-menu-button"
                        aria-label="Open menu"
                    >
                        <span></span>
                        <span></span>
                    </button>

                </div>

            </header> */}


            {/* =====================================================
          HERO
      ===================================================== */}
            <section className="panshet-hero">

                <div className="panshet-hero-image">
                    {/* <img
                         src=''
                        alt="Luxury homes surrounded by nature in Panshet"
                    /> */}


                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        poster="/images/panshet-hero-poster.jpg"
                    >
                        <source
                            src={herovideo}
                            type="video/mp4"
                        />
                    </video>



                </div>

                <div className="panshet-hero-overlay"></div>

                <div className="panshet-hero-content">

                    <div className="panshet-eyebrow">
                        SAMRIDDHI PRESENTS
                    </div>

                    {/* <h1 className="panshet-hero-title">
                        A different way
                        <br />
                        of <span>living.</span>
                    </h1> */}

                    <div className="panshet-gold-line"></div>

                    <p className="panshet-hero-description">
                        Thoughtful spaces. Natural surroundings.
                        <br />
                        A life designed around what truly matters.
                    </p>

                    <a href="#projects" className="panshet-outline-button">
                        Explore Waterscape
                        <span>→</span>
                    </a>

                </div>

                <div className="panshet-scroll-indicator">
                    <span></span>
                    <p>Scroll to explore</p>
                </div>

            </section>


            {/* =====================================================
          INTRO / ABOUT
      ===================================================== */}
            <section
                className="panshet-intro"
                id="about"
            >

                <div className="panshet-intro-content">

                    <div className="panshet-section-label">
                        ABOUT WATERSCAPE
                    </div>

                    <h2 className="panshet-section-title">
                        {/* Where nature */}
                        Where Life Meets
                        <br />
                        Nature’s  <span>Rhythm.</span>
                    </h2>

                    <p className="panshet-section-description">
                        Set amidst the tranquil landscapes of Panshet,
                        Samriddhi brings together thoughtful architecture,
                        natural beauty and a slower way of living.
                    </p>

                    <p className="panshet-section-description">
                        Designed for those who value space, privacy and
                        meaningful experiences, every detail is created
                        to bring you closer to nature.
                    </p>

                    <a href="#story" className="panshet-text-link">
                        Discover the story
                        <span>→</span>
                    </a>

                </div>

                <div className="panshet-intro-image">

                    <img
                        src={heroimg}
                        alt="Natural landscape surrounding Panshet"
                    />


                    <div className="panshet-image-caption">
                        PANSHET · PUNE .
                    </div>

                </div>

            </section>



            {/* =====================================================
          DARK STATISTICS SECTION
      ===================================================== */}
            <section
                className="panshet-stats"
                id="legacy"
            >

                <div className="panshet-stats-inner" id="projects">

                    <div className="panshet-stat">
                        <span className="panshet-stat-number">
                            100+
                        </span>

                        <span className="panshet-stat-label">
                            ACRES
                            <br />
                            Vast.Green.Serene.
                        </span>
                    </div>

                    <div className="panshet-stat">
                        <span className="panshet-stat-number">
                            4
                        </span>

                        <span className="panshet-stat-label">
                            phases
                            <br />
                            thoughtfully planned development
                        </span>
                    </div>



                    <div className="panshet-stat">
                        <span className="panshet-stat-number">
                            11,000
                        </span>

                        <span className="panshet-stat-label">
                            sq.ft onwards
                            <br />
                            Spacious Plots for Grand Farmhouses
                        </span>
                    </div>


                    <div className="panshet-stat">
                        <span className="panshet-stat-number">
                            200+
                        </span>

                        <span className="panshet-stat-label">
                            HAPPY
                            <br />
                            FAMILIES
                        </span>
                    </div>

                    {/* <div className="panshet-stat">
                        <span className="panshet-stat-number panshet-stat-word">
                            Nature
                        </span>

                        <span className="panshet-stat-label">
                            AT THE
                            <br />
                            HEART
                        </span>
                    </div> */}

                </div>

                <a href="#story" className="panshet-dark-button">
                    Our journey
                    <span>→</span>
                </a>

            </section>





            {/* --------------------------------------------------------- */}



            {/* =====================================================
    NATURAL USP — HORIZONTAL REVEAL
===================================================== */}

            <section
                className="panshet-natural-usp-scroll"
                ref={naturalUspRef}
            >

                <div className="panshet-natural-usp-sticky">

                    <div
                        className="panshet-natural-usp-track"
                        style={{
                            transform: `translateX(-${naturalUspProgress * 200
                                }vw)`
                        }}
                    >


                        {/* =================================================
                PANEL 01 — WATERFALL
            ================================================= */}

                        <div className="panshet-natural-usp-panel">

                            <img
                                src={waterfall}
                                alt="Waterfalls and lush green landscape around Panshet"
                            />

                            <div className="panshet-natural-usp-panel-overlay"></div>


                            <div className="panshet-natural-usp-panel-content">

                                <span className="panshet-natural-usp-label">
                                    NATURAL USP
                                </span>

                                <h3>
                                    Waterscape's
                                    <br />
                                    Biggest
                                    <span> Strength.</span>
                                </h3>

                                <p className="panshet-natural-usp-lead">
                                    The entire project is surrounded
                                    by nature.
                                </p>

                                <p className="panshet-natural-usp-description">
                                    Set within the ecological belt of the
                                    Panshet Backwaters, Waterscape brings
                                    you closer to panoramic lake views,
                                    mountain ranges, dense forests,
                                    seasonal waterfalls, cool weather
                                    and rich biodiversity.
                                </p>

                            </div>


                            <div className="panshet-natural-usp-location">
                                <span>01</span>
                                <strong>WATERFALLS</strong>
                            </div>

                        </div>



                        {/* =================================================
                PANEL 02 — LAKE / FARMHOUSE
            ================================================= */}

                        <div className="panshet-natural-usp-panel">

                            <img
                                src={farmhouse}
                                alt="Panshet Backwaters surrounded by nature"
                            />

                            <div className="panshet-natural-usp-panel-overlay"></div>


                            <div className="panshet-natural-usp-panel-content panshet-natural-usp-panel-content-right">

                                <span className="panshet-natural-usp-label">
                                    LIFE BY THE WATER
                                </span>

                                <h3>
                                    Where the
                                    <br />
                                    <span>water meets life.</span>
                                </h3>

                                <p className="panshet-natural-usp-description">
                                    Expansive backwaters, quiet mornings
                                    and uninterrupted views.
                                </p>

                            </div>


                            <div className="panshet-natural-usp-location">
                                <span>02</span>
                                <strong>PANSHET BACKWATERS</strong>
                            </div>

                        </div>



                        {/* =================================================
                PANEL 03 — MOUNTAINS
            ================================================= */}

                        <div className="panshet-natural-usp-panel">

                            <img
                                src={mountain}
                                alt="Mountain ranges and forests around Panshet"
                            />

                            <div className="panshet-natural-usp-panel-overlay"></div>


                            <div className="panshet-natural-usp-panel-content">

                                <span className="panshet-natural-usp-label">
                                    SURROUNDED BY GREENS
                                </span>

                                <h3>
                                    A landscape
                                    <br />
                                    <span>worth waking up to.</span>
                                </h3>

                                <p className="panshet-natural-usp-description">
                                    Mountain ranges, dense forests,
                                    mist-filled mornings and rich
                                    biodiversity become part of
                                    everyday living.
                                </p>

                            </div>


                            <div className="panshet-natural-usp-location">
                                <span>03</span>
                                <strong>WESTERN GHATS</strong>
                            </div>

                        </div>


                    </div>


                    {/* =================================================
            PROGRESS INDICATOR
        ================================================= */}

                    <div className="panshet-natural-usp-progress">

                        <span className="panshet-natural-usp-progress-number">
                            0{Math.min(
                                Math.floor(
                                    naturalUspProgress * 3
                                ) + 1,
                                3
                            )}
                        </span>

                        <div className="panshet-natural-usp-progress-line">

                            <span
                                style={{
                                    width: `${naturalUspProgress * 100
                                        }%`
                                }}
                            ></span>

                        </div>

                        <span>03</span>

                    </div>


                    <div className="panshet-natural-usp-scroll-hint">
                        SCROLL TO EXPLORE
                        <span>→</span>
                    </div>

                </div>

            </section>

            {/* =====================================================
          LIFESTYLE
      ===================================================== */}
            <section
                className="panshet-lifestyle"
                id="lifestyle"
            >

                <div className="panshet-lifestyle-image">

                    {/* <img
                        src="/images/panshet-lifestyle.jpg"
                        alt="Peaceful luxury lifestyle surrounded by nature"
                    /> */}


                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        poster="/images/panshet-hero-poster.jpg"
                    >
                        <source
                            src={expwaterscape}
                            type="video/mp4"
                        />
                    </video>




                </div>

                <div className="panshet-lifestyle-content">

                    <div className="panshet-section-label">
                        THE LIFESTYLE



                    </div>

                    <h2 className="panshet-section-title">
                        Experience The Privilege
                        <br />
                        of Unhurried <span>Time.</span>
                    </h2>

                    <p className="panshet-section-description">
                        Wake up to green horizons. Spend evenings beneath
                        open skies. Rediscover the luxury of having time,
                        space and nature around you.
                    </p>

                    <a href="#experience" className="panshet-text-link">
                        Explore the lifestyle
                        <span>→</span>
                    </a>

                </div>

            </section>




            {/* =====================================================
    PROPERTY FEATURES
===================================================== */}

            <section className="panshet-features">

                <div className="panshet-features-intro">

                    <div className="panshet-section-label">
                        THE PROPERTY
                    </div>

                    <h2 className="panshet-section-title">
                        Designed around
                        <br />
                        the way you <span>live.</span>
                    </h2>

                    <p className="panshet-section-description">
                        Every element has been thoughtfully considered
                        to create a place that feels natural, comfortable
                        and distinctly yours.
                    </p>

                </div>


                <div className="panshet-features-list">

                    <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            01
                        </span>

                        <h3>
                            Investment
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div>


                    <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            02
                        </span>

                        <h3>
                            Organic living
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div>


                    {/* <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            03
                        </span>

                        <h3>
                            Natural Landscaping
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div> */}


                    <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            03
                        </span>

                        <h3>
                            Rental income
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div>


                    {/* <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            05
                        </span>

                        <h3>
                            Premium Finishes
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div> */}


                    {/* <div className="panshet-feature-item">

                        <span className="panshet-feature-number">
                            06
                        </span>

                        <h3>
                            Privacy & Space
                        </h3>

                        <span className="panshet-feature-arrow">
                            ↗
                        </span>

                    </div> */}

                </div>

            </section>


            {/* =====================================================
    AMENITIES
===================================================== */}

            {/* =====================================================
    AMENITIES
===================================================== */}

            <section className="panshet-amenities">

                <div className="panshet-amenities-heading">

                    <div className="panshet-section-label">
                        AMENITIES
                    </div>

                    <h2 className="panshet-amenities-title">
                        Everything
                        <br />
                        <span>you need.</span>
                    </h2>

                </div>


                <div className="panshet-amenities-layout">

                    {/* IMAGE */}

                    <div className="panshet-amenities-image">

                        <img
                            key={activeAmenity.image}
                            src={activeAmenity.image}
                            alt={activeAmenity.name}
                            className="panshet-amenity-image"
                        />

                        <div className="panshet-amenity-image-overlay"></div>

                        <span className="panshet-amenity-image-label">
                            {activeAmenity.name}
                        </span>

                    </div>


                    {/* AMENITY LIST */}

                    <div className="panshet-amenities-list">

                        {amenities.map((amenity) => (

                            <div
                                key={amenity.number}
                                className={`panshet-amenity-item ${activeAmenity.name === amenity.name
                                    ? "active"
                                    : ""
                                    }`}
                                onMouseEnter={() =>
                                    setActiveAmenity({
                                        name: amenity.name,
                                        image: amenity.image,
                                    })
                                }
                            >

                                <span className="panshet-amenity-number">
                                    {amenity.number}
                                </span>

                                <h3>
                                    {amenity.name}
                                </h3>

                                <span className="panshet-amenity-arrow">
                                    ↗
                                </span>

                            </div>

                        ))}

                    </div>


                </div>

            </section>



            {/* =====================================================
    LOCATION & CONNECTIVITY
===================================================== */}

            <section className="panshet-connectivity">

                {/* SECTION INTRO */}

                <div className="panshet-connectivity-header">

                    <div className="panshet-section-label">
                        LOCATION & CONNECTIVITY
                    </div>

                    <h2 className="panshet-connectivity-title">
                        Close to the city.
                        <br />
                        <span>Far from the noise.</span>
                    </h2>

                    <p className="panshet-connectivity-description">
                        Well connected to Pune and the surrounding destinations,
                        yet tucked away in the natural tranquillity of Panshet.
                        Waterscape gives you the freedom to step away without
                        feeling far away.
                    </p>

                </div>


                {/* =================================================
        MAP
    ================================================= */}

                <div className="panshet-connectivity-map">

                    <img
                        src={panshet_map}
                        alt="Waterscape Panshet location and connectivity map"
                        className="panshet-connectivity-map-image"
                    />

                </div>


                {/* =================================================
        CONNECTIVITY DISTANCES
    ================================================= */}

                <div className="panshet-connectivity-distances">

                    {/* PUNE */}

                    <div className="panshet-connectivity-distance-item">

                        <span className="panshet-connectivity-distance-number">
                            01
                        </span>

                        <div className="panshet-connectivity-distance-info">
                            <h3>Pune</h3>
                            <span>City Centre</span>
                        </div>

                        <div className="panshet-connectivity-distance-value">
                            <strong>59</strong>
                            <span>KM</span>
                        </div>

                    </div>


                    {/* SINHAGAD */}

                    <div className="panshet-connectivity-distance-item">

                        <span className="panshet-connectivity-distance-number">
                            02
                        </span>

                        <div className="panshet-connectivity-distance-info">
                            <h3>Sinhagad</h3>
                            <span>Fort & Heritage</span>
                        </div>

                        <div className="panshet-connectivity-distance-value">
                            <strong>31</strong>
                            <span>KM</span>
                        </div>

                    </div>


                    {/* PUNE AIRPORT */}

                    <div className="panshet-connectivity-distance-item">

                        <span className="panshet-connectivity-distance-number">
                            03
                        </span>

                        <div className="panshet-connectivity-distance-info">
                            <h3>Proposed Donje Metro </h3>
                            <span>Connectivity</span>
                        </div>

                        <div className="panshet-connectivity-distance-value">
                            <strong>22</strong>
                            <span>KM</span>
                        </div>

                    </div>


                    {/* MUMBAI */}

                    <div className="panshet-connectivity-distance-item">

                        <span className="panshet-connectivity-distance-number">
                            04
                        </span>

                        <div className="panshet-connectivity-distance-info">
                            <h3>Khadakwasla</h3>
                            <span>Pune</span>
                        </div>

                        <div className="panshet-connectivity-distance-value">
                            <strong>29</strong>
                            <span>KM</span>
                        </div>

                    </div>

                </div>


                {/* =================================================
        BOTTOM STATEMENT
    ================================================= */}

                {/* <div className="panshet-connectivity-bottom">

                    <span className="panshet-connectivity-bottom-line"></span>

                    <p>
                        Connected when you need it.
                        <span> Removed when you don't.</span>
                    </p>

                </div> */}

            </section>




            {/* =====================================================
    HAPPY CUSTOMERS
===================================================== */}

            <section className="panshet-customers">

                {/* HEADER */}

                <div className="panshet-customers-header">

                    <div className="panshet-section-label">
                        SMILES FROM WATERSCAPE
                    </div>

                    <h2 className="panshet-customers-title">
                        Some places are
                        <br />
                        better when they're
                        <span> shared.</span>
                    </h2>

                </div>


                {/* TESTIMONIAL */}

                <div className="panshet-customers-content">

                    {/* =================================================
        CUSTOMER IMAGE
    ================================================= */}

                    {/* <div className="panshet-customer-image">

                        <img
                            key={customerTestimonials[activeCustomer].image}
                            src={customerTestimonials[activeCustomer].image}
                            alt={customerTestimonials[activeCustomer].name}
                        />

                        <div className="panshet-customer-image-overlay"></div>

                        <div className="panshet-customer-image-number">

                            {String(activeCustomer + 1).padStart(2, "0")}

                        </div>

                    </div> */}


                    {/* =================================================
        TESTIMONIAL
    ================================================= */}

                    <div className="panshet-customer-testimonial">

                        <div className="panshet-customer-quote">
                            “
                        </div>


                        <blockquote key={activeCustomer}>

                            {customerTestimonials[activeCustomer].quote}

                        </blockquote>


                        <div
                            className="panshet-customer-details"
                            key={`details-${activeCustomer}`}
                        >

                            <strong>
                                {customerTestimonials[activeCustomer].name}
                            </strong>

                            <span>
                                {customerTestimonials[activeCustomer].role}
                            </span>

                        </div>


                        {/* =================================================
            NAVIGATION
        ================================================= */}

                        <div className="panshet-customer-navigation">

                            <button
                                type="button"
                                className="panshet-customer-nav-button"
                                onClick={previousCustomer}
                                aria-label="Previous testimonial"
                            >
                                ←
                            </button>


                            <div className="panshet-customer-progress">

                                <span className="active">

                                    {String(activeCustomer + 1).padStart(2, "0")}

                                </span>


                                <div className="panshet-customer-progress-line">

                                    <span
                                        style={{
                                            width: `${((activeCustomer + 1) /
                                                customerTestimonials.length) * 100
                                                }%`
                                        }}
                                    ></span>

                                </div>


                                <span>

                                    {String(
                                        customerTestimonials.length
                                    ).padStart(2, "0")}

                                </span>

                            </div>


                            <button
                                type="button"
                                className="panshet-customer-nav-button"
                                onClick={nextCustomer}
                                aria-label="Next testimonial"
                            >
                                →
                            </button>

                        </div>

                    </div>

                </div>

            </section>




            {/* =====================================================
          PROJECT CTA
      ===================================================== */}
            <section
                className="panshet-project-cta"

            >

                <div className="panshet-project-cta-content">

                    <div className="panshet-section-label">
                        THE WATERSCAPE EXPERIENCE
                    </div>

                    <h2 className="panshet-cta-title">
                        Come closer
                        <br />
                        to <span>nature.</span>
                    </h2>

                    <p>
                        Discover a place where thoughtful design,
                        natural surroundings and meaningful living
                        come together.
                    </p>

                    <a
                        href="https://wa.me/919766010099?text=Hi%2C%20I%27m%20interested%20in%20Waterscape%20and%20would%20like%20to%20schedule%20a%20site%20visit."
                        className="panshet-gold-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Plan a visit
                        <span>→</span>
                    </a>

                </div>

            </section>


            {/* =====================================================
          FOOTER
      ===================================================== */}
            {/* <footer
                className="panshet-footer"
                id="contact"
            >

                <div className="panshet-footer-top">

                    <div className="panshet-footer-brand">

                        <div className="panshet-footer-logo">
                            SAMRIDDHI
                        </div>

                        <p>
                            Built on trust.
                            <br />
                            Designed for living.
                        </p>

                    </div>


                    <div className="panshet-footer-column">

                        <h4>Explore</h4>

                        <a href="#projects">Projects</a>
                        <a href="#about">About Us</a>
                        <a href="#lifestyle">Lifestyle</a>
                        <a href="#legacy">Our Legacy</a>

                    </div>


                    <div className="panshet-footer-column">

                        <h4>Connect</h4>

                        <a href="#contact">Contact Us</a>
                        <a href="#visit">Plan a Visit</a>
                        <a href="#location">Locations</a>

                    </div>


                    <div className="panshet-footer-column">

                        <h4>Follow</h4>

                        <a href="#instagram">Instagram</a>
                        <a href="#facebook">Facebook</a>
                        <a href="#linkedin">LinkedIn</a>

                    </div>

                </div>


                <div className="panshet-footer-bottom">

                    <span>
                        © {new Date().getFullYear()} Samriddhi Group
                    </span>

                    <span>
                        Privacy Policy
                    </span>

                </div>

            </footer> */}

        </main>
    );
};

export default Panshet;